module.exports = __webpack_public_path__ + "img/backgroundImage.3e7bb30f.png";